import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context13; _forEachInstanceProperty(_context13 = ownKeys(source, true)).call(_context13, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context14; _forEachInstanceProperty(_context14 = ownKeys(source)).call(_context14, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Component } from 'react';
import { isFunction, uuid } from './utils';

var _push = function push() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var copy = _toConsumableArray(array);

  copy.push(_objectSpread({
    id: uuid()
  }, field));
  return copy;
};

var _pop = function pop() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var copy = _toConsumableArray(array);

  copy.pop();
  return copy;
};

var _unshift = function unshift() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var copy = _toConsumableArray(array);

  copy.unshift(_objectSpread({
    id: uuid()
  }, field));
  return copy;
};

var _swap = function swap() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var indexA = arguments.length > 1 ? arguments[1] : undefined;
  var indexB = arguments.length > 2 ? arguments[2] : undefined;

  var copy = _toConsumableArray(array);

  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};

var _move = function move() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var from = arguments.length > 1 ? arguments[1] : undefined;
  var to = arguments.length > 2 ? arguments[2] : undefined;

  var copy = _toConsumableArray(array);

  var value = copy[from];

  _spliceInstanceProperty(copy).call(copy, from, 1);

  _spliceInstanceProperty(copy).call(copy, to, 0, value);

  return copy;
};

var _insert = function insert() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var copy = _toConsumableArray(array);

  _spliceInstanceProperty(copy).call(copy, index, 0, _objectSpread({
    id: uuid()
  }, field));

  return copy;
};

var _replace = function replace() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var copy = _toConsumableArray(array);

  copy[index] = _objectSpread({
    id: uuid()
  }, field);
  return copy;
};

var _remove = function remove() {
  var _context;

  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_sliceInstanceProperty(array).call(array, 0, index)), _toConsumableArray(_sliceInstanceProperty(array).call(array, index + 1, array.length)));
};

var FieldArray =
/*#__PURE__*/
function (_Component) {
  _inherits(FieldArray, _Component);

  function FieldArray(props) {
    var _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11;

    var _this;

    _classCallCheck(this, FieldArray);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FieldArray).call(this, props));
    _this.state = {
      fields: _mapInstanceProperty(_context2 = _this.props.initialFields).call(_context2, function (field) {
        return _objectSpread({
          id: uuid()
        }, field);
      })
    };
    _this.fieldArrayState = {
      push: _bindInstanceProperty(_context3 = _this.push).call(_context3, _assertThisInitialized(_this)),
      pop: _bindInstanceProperty(_context4 = _this.pop).call(_context4, _assertThisInitialized(_this)),
      unshift: _bindInstanceProperty(_context5 = _this.unshift).call(_context5, _assertThisInitialized(_this)),
      swap: _bindInstanceProperty(_context6 = _this.swap).call(_context6, _assertThisInitialized(_this)),
      move: _bindInstanceProperty(_context7 = _this.move).call(_context7, _assertThisInitialized(_this)),
      insert: _bindInstanceProperty(_context8 = _this.insert).call(_context8, _assertThisInitialized(_this)),
      replace: _bindInstanceProperty(_context9 = _this.replace).call(_context9, _assertThisInitialized(_this)),
      remove: _bindInstanceProperty(_context10 = _this.remove).call(_context10, _assertThisInitialized(_this)),
      getFieldProps: _bindInstanceProperty(_context11 = _this.getFieldProps).call(_context11, _assertThisInitialized(_this))
    };
    return _this;
  }

  _createClass(FieldArray, [{
    key: "push",
    value: function push(field) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _push(prevState.fields, field)
        });
      });
    }
  }, {
    key: "pop",
    value: function pop() {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _pop(prevState.fields)
        });
      });
    }
  }, {
    key: "unshift",
    value: function unshift() {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _unshift(prevState.fields)
        });
      });
    }
  }, {
    key: "swap",
    value: function swap(indexA, indexB) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _swap(prevState.fields, indexA, indexB)
        });
      });
    }
  }, {
    key: "move",
    value: function move(from, to) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _move(prevState.fields, from, to)
        });
      });
    }
  }, {
    key: "insert",
    value: function insert(index, field) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _insert(prevState.fields, index, field)
        });
      });
    }
  }, {
    key: "replace",
    value: function replace(index, field) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _replace(prevState.fields, index, field)
        });
      });
    }
  }, {
    key: "remove",
    value: function remove(index) {
      this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          fields: _remove(prevState.fields, index)
        });
      });
    }
  }, {
    key: "getFieldProps",
    value: function getFieldProps(field, index) {
      var _context12;

      var _this$props = this.props,
          name = _this$props.name,
          initialFields = _this$props.initialFields,
          render = _this$props.render,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["name", "initialFields", "render", "children"]);

      return _objectSpread({
        key: field.id,
        name: _concatInstanceProperty(_context12 = "".concat(name, ".")).call(_context12, index)
      }, rest, {}, field);
    }
  }, {
    key: "getFieldArrayProps",
    value: function getFieldArrayProps() {
      var fields = this.state.fields;
      return _objectSpread({
        fields: fields
      }, this.fieldArrayState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          render = _this$props2.render,
          children = _this$props2.children;
      var fieldArrayState = this.getFieldArrayProps();
      return isFunction(children) ? children(fieldArrayState) : isFunction(render) ? render(fieldArrayState) : null;
    }
  }]);

  return FieldArray;
}(Component);

_defineProperty(FieldArray, "defaultProps", {
  initialFields: []
});

export default FieldArray;